export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Talisman.1ad4ba77.jpg";